export const WORKLOG_ORIGINS = {
  VERTE_OFFICE: 'VERTE_OFFICE',
  POPUP_TIMER_FORM: 'POPUP_TIMER_FORM',
  POPUP_FINALIZED_FORM: 'POPUP_FINALIZED_FORM',
  PENDING_TASK_FORM: 'PENDING_TASK_FORM',
} as const

export type WorklogOrigin = typeof WORKLOG_ORIGINS[keyof typeof WORKLOG_ORIGINS]

export const WORKLOG_ORIGIN_EXTRAS_KEY = 'origin'

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Object.prototype.toString.call(value) === '[object Object]'
}

export function mergeWorklogOriginIntoExtras(
  extras: unknown,
  origin: WorklogOrigin
): Record<string, unknown> {
  const baseExtras = isPlainObject(extras) ? extras : {}

  return {
    ...baseExtras,
    [WORKLOG_ORIGIN_EXTRAS_KEY]: origin,
  }
}

export function withWorklogCreationOrigin<T extends Record<string, unknown>>(
  data: T,
  origin: WorklogOrigin
): T & { extras: Record<string, unknown> } {
  return {
    ...data,
    extras: mergeWorklogOriginIntoExtras(data.extras, origin),
  }
}
